import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router";
import {
  getArticleAuthorNamesV2,
  getArticleKeywords,
  getArticleStoryThread,
} from "@components/GAData/helper";
import { ArticlePaidModeType } from "@pages/Article/utils/enums";
import { FeedArticleData } from "@pages/Article/utils/types";
import { dayjsSingaporeTimezone, getEnvironment } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";
import dayjs from "dayjs";
import posthog from "posthog-js";

export const useHookUpdateUrlArticle = (
  urlPath: string,
  isNavigate: boolean,
  article: FeedArticleData,
  variant?: string,
  setArticleObj?: (article: FeedArticleData) => void
) => {
  const navigate = useNavigate();

  const isPremium = article.paidMode === ArticlePaidModeType.PREMIUM;

  const mainSection = article?.sections?.[0];
  const parentSection = mainSection?.parent || mainSection;

  const { ref } = useInView({
    threshold: 0.01,
    onChange: (inView) => {
      if (!inView || !isNavigate || !article?.id) return;

      if (typeof setArticleObj === "function") {
        setArticleObj(article);
      }

      navigate(urlPath, { preventScrollReset: true });

      if (typeof window === "undefined") return;

      const publishedDate = dayjs(article?.publishTime)
        .tz(dayjsSingaporeTimezone)
        .format("YYYY-MM-DD HH:mm:ss");

      window.dataLayer = window.dataLayer || [];

      (window.dataLayer as object[]).push({
        ...window._data,
        ...{
          event: "virtual_pv",
          virtual_url: urlPath.replace("/", ""),
          cue_articleid: article?.id,
          articleid: article?.id,
          author: getArticleAuthorNamesV2(article?.authors),
          chapter1: mainSection.uniqueName,
          contentcat: isPremium ? 2 : 1,
          contenttype: "1",
          keyword: getArticleKeywords(article.tags || []),
          level2: parentSection.uniqueName,
          pubdate: publishedDate,
          title: article?.title,
          story_threads: getArticleStoryThread(
            article.tags || []
          )?.name.toLowerCase(),
          abVariant: variant || "control",
        },
      });

      // For PostHog tracking
      const currentUrl = getEnvironmentDomain(getEnvironment()) + urlPath;
      posthog.capture("$pageview", {
        $pathname: urlPath,
        $current_url: currentUrl,
      });
    },
  });

  return { ref };
};
